import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
let fileUploadIndex = 0;
const addUploadId = (payload)=>_object_spread_props(_object_spread({}, payload), {
        uploadId: ++fileUploadIndex
    });
export const uploadFile = createAction(`${actionKey}/UPLOAD`, (payload)=>addUploadId(payload));
export const uploadFiles = createAction(`${actionKey}/UPLOAD_MULTI`, (files)=>({
        files: files.map(addUploadId)
    }));
export const cancelFileUpload = createAction(`${actionKey}/UPLOAD_CANCEL`, (payload)=>payload);
export const uploadSuccess = createAction(`${actionKey}/UPLOAD/SUCCESS`, (uploadId, deviationId)=>({
        uploadId,
        deviationId
    }));
export const uploadFailure = createAction(`${actionKey}/UPLOAD/FAILURE`, (uploadId, error)=>({
        uploadId,
        error
    }));
export const uploadProgress = createAction(`${actionKey}/UPLOAD/PROGRESS`, (uploadId, progress)=>({
        uploadId,
        progress
    }));
export const uploadFileImmediately = createAction(`${actionKey}/UPLOAD/IMMEDIATE`, (payload)=>payload);
export const clearInactiveUploads = createAction(`${actionKey}/CLEAR_INACTIVE_UPLOADS`, ()=>({}));
export const uploadAttachment = createAction(`${actionKey}/UPLOAD_ATTACHMENT`, (payload)=>addUploadId(payload));
export const uploadAttachmentImmediately = createAction(`${actionKey}/UPLOAD_ATTACHMENT/IMMEDIATE`, (payload)=>payload);
export const uploadAttachmentProgress = createAction(`${actionKey}/UPLOAD_ATTACHMENT/PROGRESS`, (uploadId, progress)=>({
        uploadId,
        progress
    }));
export const uploadAttachmentSuccess = createAction(`${actionKey}/UPLOAD_ATTACHMENT/SUCCESS`, (uploadId, fileId, deviationId, file)=>({
        uploadId,
        fileId,
        deviationId,
        file
    }));
export const uploadAttachmentFailure = createAction(`${actionKey}/UPLOAD_ATTACHMENT/FAILURE`, (uploadId, error)=>({
        uploadId,
        error
    }));
export const cancelAttachmentUpload = createAction(`${actionKey}/UPLOAD_ATTACHMENT/CANCEL`, (payload)=>payload);
export const removeAttachment = createAction(`${actionKey}/UPLOAD_ATTACHMENT/REMOVE`, (fileId, deviationId, type, onSuccess)=>({
        fileId,
        deviationId,
        type,
        onSuccess
    }));
export const repositionAttachment = createAction(`${actionKey}/ATTACHMENT/REPOSITION`, (fileId, deviationId, type, position)=>({
        fileId,
        deviationId,
        type,
        position
    }));
export const setAttachmentCaption = createAction(`${actionKey}/ATTACHMENT/SET_CAPTION`, (fileId, deviationId, type, caption)=>({
        fileId,
        deviationId,
        type,
        caption
    }));
export const setMainDeviationCaption = createAction(`${actionKey}/MAIN_DEVIATION/SET_CAPTION`, (deviationId, caption)=>({
        deviationId,
        caption
    }));
export const uploadDocument = createAction(`${actionKey}/UPLOAD_DOCUMENT`, (payload)=>payload);
export const uploadDocumentProgress = createAction(`${actionKey}/UPLOAD_DOCUMENT/PROGRESS`, (documentType, progress)=>({
        documentType,
        progress
    }));
export const uploadDocumentSuccess = createAction(`${actionKey}/UPLOAD_DOCUMENT/SUCCESS`, (documentType, documentUrl)=>({
        documentType,
        documentUrl
    }));
export const uploadDocumentFailure = createAction(`${actionKey}/UPLOAD_DOCUMENT/FAILURE`, (documentType, error)=>({
        documentType,
        error
    }));
export const cancelDocumentUpload = createAction(`${actionKey}/UPLOAD_DOCUMENT/CANCEL`, (documentType)=>({
        documentType
    }));

//# sourceMappingURL=actions.js.map